






















































































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component
export default class CensusUploadRules extends Vue {
  custodianSettingStore = useCustodianSettingsStore();

  get accountTypeUpdatesAcceptedCopy (): string {
    return this.custodianSettingStore.disableEmployeeEdit ? "N" : "Y";
  }

}
